module.exports = __webpack_public_path__ + "static/media/tti_with_talentx@2x.4b25e4d3.png";